module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/sp-cover-1-d6b67d8002bc13f0b57faf83a3a03b4d.webp";